var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"STUDENT SERVICES","title":"Discipline Management","description":"Record conduct, manage incidents and recognize positive student behaviour.","count-label":"discipline tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }